// Helpers temporali puri per i prodotti forecast a step discreti.

function finiteTime(value) {
    if (value === null || value === undefined || value === '') return null;
    const time = Number(value);
    return Number.isFinite(time) ? time : null;
}

/**
 * Restituisce lo step più vicino soltanto se T ricade nella copertura della
 * timeline. I bordi esterni valgono mezzo intervallo rispetto allo step
 * adiacente: uno step orario delle 00:00 resta quindi valido fino alle 00:30,
 * ma non viene trascinato per tutte le ore successive.
 */
export function coveredTimelineEntry(entries, targetMs, timeOf) {
    const target = finiteTime(targetMs);
    if (target === null || !Array.isArray(entries) || typeof timeOf !== 'function') return null;

    const timed = entries
        .map((entry, order) => ({ entry, order, time: finiteTime(timeOf(entry)) }))
        .filter(row => row.time !== null)
        .sort((a, b) => a.time - b.time || a.order - b.order);
    if (!timed.length) return null;

    if (timed.length === 1) {
        return target === timed[0].time ? timed[0].entry : null;
    }

    const first = timed[0];
    const last = timed[timed.length - 1];
    const next = timed.find(row => row.time > first.time);
    const previous = [...timed].reverse().find(row => row.time < last.time);
    if (!next || !previous) return target === first.time ? first.entry : null;

    const startMs = first.time - (next.time - first.time) / 2;
    const endMs = last.time + (last.time - previous.time) / 2;
    if (target < startMs || target > endMs) return null;

    return timed.reduce((best, row) => {
        const distance = Math.abs(row.time - target);
        const bestDistance = Math.abs(best.time - target);
        // A parità resta sullo step precedente: evita di anticipare il cambio.
        return distance < bestDistance ? row : best;
    }, first).entry;
}
